import { datepikerActionsTypes } from './datepikerActionsTypes';

const { FILTER_DATE } = datepikerActionsTypes;

export const filterDates = (filterdates) => {
	return {
		type: FILTER_DATE,
		payload: filterdates,
	};
};
